export const HOME = {
  emergentLink: "home-emergent-link",
  // Nav
  navLogo: "nav-logo",
  navProducts: "nav-products",
  navAbout: "nav-about",
  navContact: "nav-contact",
  navInquiryBtn: "nav-inquiry-btn",
  // Hero
  heroHeadline: "hero-headline",
  heroCta: "hero-cta",
  heroScrollHint: "hero-scroll-hint",
  // Products
  productsSection: "products-section",
  productCard: (code) => `product-card-${code}`,
  productInquireBtn: (code) => `product-inquire-${code}`,
  productImage: (code) => `product-image-${code}`,
  // About
  aboutSection: "about-section",
  // Inquiry modal/form
  inquiryDialog: "inquiry-dialog",
  inquiryProductLabel: "inquiry-product-label",
  inquiryName: "inquiry-name",
  inquiryEmail: "inquiry-email",
  inquiryPhone: "inquiry-phone",
  inquiryLocation: "inquiry-location",
  inquiryProjectType: "inquiry-project-type",
  inquiryMessage: "inquiry-message",
  inquirySubmit: "inquiry-submit",
  inquirySuccess: "inquiry-success",
  inquiryError: "inquiry-error",
  inquiryClose: "inquiry-close",
  // Footer
  footerSection: "footer-section",
  footerDomain: "footer-domain",
};
